import { BiRightArrowAlt } from "react-icons/bi";
import React, { useEffect } from "react";
import Heading from "../Highlightedheading/Heading";
import Button from "../Buttons/Button";
import Web_img from "../../assets/webSeries/web_img.png";
import Tag_img from "../../assets/webSeries/tag_img.png";
import Mobile_bg from "../../assets/webSeries/Mobile_bg_2.png";
import model from "../../assets/webSeries/Model.png";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";

const Section = () => {
  const navigate = useNavigate();
  const { width } = useWindowSize();

  const dummyData = [
    {
      id: 1,
      src: "Web_img.png",
      headingText: "WEB SERIES",
      backgroundImage: Web_img,
      mobileBackgroundImage: Mobile_bg,
      imageUrl: Tag_img,
      type: "web show",
      releaseInfo: {
        year: "2024",
        season: "1 Season",
        languages: "7 Languages",
        rating: "U/A 16+",
      },
      description:
        "Karma Talwar seeks vengeance for her father’s downfall, exposing corruption and betrayal in a gripping tale of justice and redemption.",
      genres: ["Drama", "Thriller"],
      buttonText: "WATCH TRAILER",
      // videoId: 330036411,
      videoId: "jNmb7LF0UOE",
    },
  ];

  function handleWebSeries(id) {
    navigate(`/watch/${id}`);
  }

  return (
    <section>
      {dummyData.map((data, i) => (
        <div
          key={`webseries-${i}`}
          className="bg-no-repeat bg-cover overflow-hidden "
        >
          <div className="flex justify-between px-4 pt-[60px] md:pl-[7.2vw] md:pr-[4.2vw] md:pt-[120px]">
            <Heading headingText="WEB SERIES" />

            {/* <div className="absolute flex items-center justify-center  md:right-[25.42vw] sm:top-[-10.04vh] top-[-4.63vh]">
              <img
                src="images/Ellipse 63.png"
                alt="elipse"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div> */}

            <Button
              buttonText={"VIEW ALL"}
              onClick={() => navigate("/long-format/")}
              // customCss={"md:mt-20 mt-6 md:pr-[3vw] !z-30"}
              customCss={
                "self-end -translate-y-[50%] tab:-translate-y-[100%] !z-30"
              }
            />
          </div>

          <div className="relative bg-bottom bg-no-repeat bg-cover mt-8 tab:mt-0">
            {width > 992 ? (
              <img
                src={data?.backgroundImage}
                height={1204}
                width={1920}
                alt="Background Image"
                className="absolute w-full mt-[-14.5%] object-cover"
              />
            ) : (
              <img
                src={data?.mobileBackgroundImage}
                height={1204}
                width={1920}
                alt="Background Image"
                className="absolute w-full h-full object-cover"
              />
            )}
            <div className="relative font-montserrat px-4 md:px-[7.2vw] py-14 2xl-plus:py-32 3xl-plus:py-40 tab:w-[50%] 2xl:w-[40%]">
              <img
                src={data?.imageUrl}
                alt={data?.headingText}
                className="w-[75%] mr-auto tab:mr-0"
              />
              <p className="font-semibold text-14 leading-[14px] sm:text-24 sm:leading-[24px] 3xl-plus:text-[28px] 3xl-plus:leading-[28px] text-green-end capitalize mt-4 sm:mt-10 3xl-plus:mt-12">
                {data?.type}
              </p>
              <div className="flex gap-4 items-center justify-start mt-4 sm:mt-6 3xl-plus:mt-8">
                <p className="font-semibold  text-14  leading-[14px] sm:text-24 sm:leading-[24px] 3xl-plus:text-[28px] 3xl-plus:leading-[28px] text-white">
                  {data?.releaseInfo?.year}
                </p>
                {data.releaseInfo?.season && (
                  <>
                    <div className="size-2 rounded-full bg-white/50"></div>
                    <p className="font-semibold text-14  leading-[14px] sm:text-24 sm:leading-[24px] 3xl-plus:text-[28px] 3xl-plus:leading-[28px] text-white">
                      {data?.releaseInfo?.season}
                    </p>
                  </>
                )}
              </div>
              <p className="3xl-plus:mt-8 sm:mt-6 mt-4 text-16 leading-[26px] sm:leading-[28px] sm:text-18 3xl-plus:text-[28px] 3xl-plus:leading-[32px] text-white font-light">
                {data?.description}
              </p>

              {/* Button */}
              <div className="border-[1px] mt-4 w-fit border-white py-[2.27vw] px-[2.27vw] md:py-[1.1vw] md:px-[1.7vw] lg:mt-[1.55vw] rounded-full lg:rounded-[3.40vw] relative overflow-hidden group">
                <button
                  className="flex items-center gap-x-3 text-white uppercase font-montserrat text-[3.73vw] leading-[0] md:text-[1.25vw] md:leading-[0] font-semibold opacity-100 relative z-10"
                  onClick={() => handleWebSeries(data?.videoId)}
                >
                  Watch Trailer
                  <div className="flex items-center justify-center bg-[#4AB66C] rounded-full p-[2px] transition-colors duration-300 ease-in-out group-hover:bg-white">
                    <BiRightArrowAlt className="text-white w-[6.5vw] md:w-[2.60417vw] h-auto transition-transform duration-300 ease-in-out group-hover:text-[#22AD86] -rotate-45 group-hover:rotate-0" />
                  </div>
                </button>
                <div className="absolute inset-0 bg-custom-vertical-gradient transform translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></div>
              </div>
            </div>
            <img
              src={model}
              alt="Background Image"
              className="relative ml-auto -mt-[5%] w-[75%] tab:hidden"
            />
          </div>
        </div>
      ))}
    </section>
  );
};

export default Section;
